import {
  AppsListComponent,
  ScreenshotsComponent,
  TextComponent,
} from '@web-catalog/components/Featuring/parts';
import {ScrollTarget} from '@web-catalog/components/ScrollTarget/ScrollTarget';

import {AppsSelectionContent} from '@web-catalog/types';

const componentMap: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key in AppsSelectionContent['type']]: React.ComponentType<any> | null;
} = {
  TEXT: TextComponent,
  SCREENSHOTS: ScreenshotsComponent,
  APPS: AppsListComponent,
  EVENTS: null,
};

export const ContentRenderer = ({
  content,
  featuringName,
  featuringId,
  featuringType,
  isEnablePreorderRedesign,
}: {
  content: Array<AppsSelectionContent>;
  featuringName?: string;
  featuringId: string;
  featuringType?: string;
  isEnablePreorderRedesign?: boolean;
}) => {
  return content.map((item, index) => {
    const Component = componentMap[item.type];

    return Component ? (
      <ScrollTarget
        eventName="scrollDown.scroll"
        scrollDepth={`${index + 1}`}
        key={item.contentId}
      >
        <Component
          content={item}
          featuringName={featuringName}
          featuringId={featuringId}
          featuringType={featuringType}
          isEnablePreorderRedesign={isEnablePreorderRedesign}
        />
      </ScrollTarget>
    ) : null;
  });
};
